<template>
  <section
    id="app-mast-main"
    class="app-section app-section-light container-fluid p-0"
  >
    <section class="app-hero-img">
      <img
        data-src="/codesource/img/giftcards/hero-img.jpg"
        class="lazy img-fluid"
        alt="The Gift of Travel"
        title="The Gift of Travel"
      />
    </section>
    <main class="app-mast-main">
      <section class="app-section app-section-grey container-fluid py-5 mx-0">
        <h1 class="section-heading">Give the Gift of Travel</h1>
        <div id="app" class="container p-0">
          <div></div>
          <section class="row">
            <div class="col-10 offset-1 col-sm-4 offset-sm-4"></div>
          </section>

          <section class="row">
            <div class="col-12 col-sm-5 col-md-4">
              <img
                data-src="/codesource/img/giftcards/giftcard.png"
                alt="Trailfinders Giftcard"
                title="Trailfinders Giftcard"
                class="img-fluid lazy mb-5"
              />
            </div>

            <div class="col-12 col-sm-7 col-md-8">
              <p class="text-strong p-sm">
                Trailfinders Electronic Gift Cards are perfect for anyone who
                enjoys the thrill of travelling. They also make ideal prizes in
                company incentives, competitions or raffles.
              </p>

              <ul class="m-2">
                <li>Valid indefinitely</li>
                <li>Easy to use and redeem</li>
                <li>
                  All gift card money is secured and protected in the
                  Trailfinders Trust Account
                </li>
                <li>
                  Purchase any amount from {{ GENERAL_CONFIG.CURRENCY }}10 to
                  {{ GENERAL_CONFIG.CURRENCY }}10,000 online (you may purchase
                  values of more than {{ GENERAL_CONFIG.CURRENCY }}10,000 in person
                  at one of our travel centres)
                </li>
              </ul>

              <b-form
                @submit.prevent=""
                class="card bg-grey border-0 rounded-0"
                v-if="!amexComplete"
              >
                <p class="card-header fs-5 p-2">
                  <i class="material-icons icon-lg align-middle"
                    >card_giftcard</i
                  >
                  <span class="ms-2">Gift Card Value </span>
                </p>
                <div class="card-body" id="giftCardApp">
                  <section class="row form-group">
                    <div class="col-12 d-none">
                      <label for="CARDVALUE">Card value in</label>
                    </div>

                    <div class="col-12">
                      <div class="input-group pt-2 d-flex flex-nowrap">
                        <span class="input-group-text px-3">{{
                          GENERAL_CONFIG.CURRENCY
                        }}</span>
                        <b-form-input
                          name="CARDVALUE"
                          id="CARDVALUE"
                          class="form-control"
                          placeholder="Enter Card Value"
                          v-model.trim="$v.card.ccpayment.$model"
                          :state="validateState('card', 'ccpayment')"
                          @change="touchField($v.card.ccpayment)"
                          type="number"
                        ></b-form-input>
                      </div>
                      <div
                        class="alert alert-danger mb-0"
                        v-if="
                          !$v.card.ccpayment.between ||
                            $v.card.ccpayment.$model === ''
                        "
                      >
                        Please note gift cards to a minimum value of
                        {{ GENERAL_CONFIG.CURRENCY }}10 and a maximum total
                        value of {{ GENERAL_CONFIG.CURRENCY }}10,000 can be
                        purchased online. If you wish to purchase a higher value
                        please visit your local travel centre.
                      </div>
                    </div>
                  </section>

                  <hr />

                  <p class="card-header fs-5 p-2">
                    <i class="material-icons icon-lg align-middle"
                      >perm_contact_calendar</i
                    >
                    <span class="ms-2">Gift Card Sender</span>
                  </p>

                  <div class="card-body p-0">
                    <section class="row form-group">
                      <div class="col-12 d-none pt-3">
                        <label class="pt-3" for="input-small">Title</label>
                      </div>

                      <div class="col-6 col-md-4 pt-3">
                        <b-form-select
                          id="title-input-1"
                          class="form-select"
                          name="title-input-1"
                          v-model.trim="$v.sender.title.$model"
                          :options="titleOptions"
                          :state="validateState('sender', 'title')"
                          @change="touchField($v.sender.title)"
                        >
                        </b-form-select>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.sender.title.$dirty && !$v.sender.title.required
                          "
                        >
                          Please select a title.
                        </div>
                      </div>

                      <div class="col-12 d-none pt-3">
                        <label class="pt-3" for="input-small">First Name</label>
                      </div>

                      <div class="col-6 col-md-4 pt-3">
                        <b-form-input
                          id="example-input-3"
                          class="rounded"
                          v-model.trim="$v.sender.firstname.$model"
                          placeholder="Firstname"
                          :state="validateState('sender', 'firstname')"
                          @change="touchField($v.sender.firstname)"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.sender.firstname.$dirty &&
                              !$v.sender.firstname.required
                          "
                        >
                          Field is required
                        </div>
                      </div>

                      <div class="col-12 d-none pt-3">
                        <label class="pt-3" for="input-small">Surname</label>
                      </div>

                      <div class="col-6 col-md-4 pt-3">
                        <b-form-input
                          id="example-input-4"
                          class="rounded"
                          v-model.trim="$v.sender.surname.$model"
                          placeholder="Surname"
                          :state="validateState('sender', 'surname')"
                          @change="touchField($v.sender.surname)"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.sender.surname.$dirty &&
                              !$v.sender.surname.required
                          "
                        >
                          Field is required
                        </div>
                      </div>
                    </section>

                    <section class="row form-group">
                      <div class="col-12 d-none">
                        <label for="PHONE">Contact number</label>
                      </div>
                      <div class="col-12">
                        <b-form-input
                          placeholder="Contact Telephone Number"
                          v-model="$v.sender.phone.$model"
                          :state="validateState('sender', 'phone')"
                          @change="touchField($v.sender.phone)"
                        ></b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.sender.phone.$dirty && !$v.sender.phone.required
                          "
                        >
                          Field is required
                        </div>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            !$v.sender.phone.numeric ||
                              !$v.sender.phone.minLength
                          "
                        >
                          Must be a valid number
                        </div>
                      </div>
                    </section>

                    <section class="row form-group">
                      <div class="col-12 d-none">
                        <label for="EMAIL">Email address</label>
                      </div>
                      <div class="col-12">
                        <b-form-input
                          type="email"
                          placeholder="Email Address"
                          v-model="$v.sender.email.$model"
                          :state="validateState('sender', 'email')"
                          @change="touchField($v.sender.email)"
                        ></b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.sender.email.$dirty && !$v.sender.email.required
                          "
                        >
                          Field is required
                        </div>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            !$v.sender.email.email || !$v.sender.email.minLength
                          "
                        >
                          Must be a valid e-mail
                        </div>
                      </div>
                    </section>

                    <section class="row form-group">
                      <div class="col-12 d-none">
                        <label for="EMAILCONFIRM">Email address</label>
                      </div>
                      <div class="col-12">
                        <b-form-input
                          type="email"
                          placeholder="Confirm Email Address"
                          v-model="$v.sender.emailconfirm.$model"
                          :state="validateState('sender', 'emailconfirm')"
                          @change="touchField($v.sender.emailconfirm)"
                        ></b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.sender.emailconfirm.$dirty &&
                              !$v.sender.emailconfirm.required
                          "
                        >
                          Field is required
                        </div>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="!$v.sender.emailconfirm.sameAs"
                        >
                          Email Address does not match
                        </div>
                      </div>
                    </section>

                    <section class="form-group row">
                      <div class="col-12 mt-3">
                        <label for="Postcode">Find your address</label>
                      </div>

                      <!-- International Payment Option -->
                      <div class="col-sm-12">
                        <div role="alert">
                          <b-col
                            style="padding-left:0px; padding-right:0px;"
                            sm="12"
                          >
                            <b-form-checkbox
                              id="intAddress"
                              v-model.trim="intAddress"
                              name="intAddress"
                              value="yes"
                              unchecked-value="''"
                              size="sm"
                              class="float-start"
                            >
                              <p class="mx-md-1">
                                Tick here if your address is outside of
                                {{ site }}
                              </p>
                            </b-form-checkbox>
                          </b-col>
                        </div>
                      </div>

                      <div class="col-12" v-show="intAddress === 'yes'">
                        <div class="select-holder">
                          <p>Select a Country:</p>
                          <b-form-select
                            v-model.trim="sender.countryCode"
                            id="countryCode"
                            class="form-select"
                            name="countryCode"
                            :options="countryCodes"
                            :state="validateState('sender', 'countryCode')"
                            @change="touchField($v.sender.countryCode)"
                          >
                          </b-form-select>
                          <div
                            class="alert alert-danger mb-0"
                            v-if="
                              $v.sender.countryCode.$dirty &&
                                !$v.sender.countryCode.required
                            "
                          >
                            Please select a Country.
                          </div>
                        </div>
                      </div>
                      <div v-if="isIe && intAddress !== 'yes'" class="col-10">
                        <Autoaddress
                          licencekey="2e9c9e91-eda5-472e-ae24-7d3569bec687"
                          vanityMode="true"
                          addressProfile="Demo5LineV2"
                          country="ie"
                          language="en"
                          noResultFoundLabel="No search results have been found.Please enter address manually below."
                          @onAddressFound="foundIEAddress($event)"
                        />
                      </div>

                      <div v-if="!isIe && intAddress !== 'yes'" class="col-10">
                        <b-form-input
                          class="rounded mt-2"
                          v-model="sender.postcodeSearch"
                          placeholder="Search Postcode"
                          aria-describedby="input-10-live-feedback"
                        >
                        </b-form-input>
                      </div>
                      <div
                        v-if="!isIe && intAddress !== 'yes'"
                        class="col-2 d-flex justify-content-center"
                      >
                        <b-button
                          @click="addressInfo"
                          class="btn btn-success mt-2 text-white"
                          size="sm"
                        >
                          Find
                        </b-button>
                      </div>
                      <div v-show="addressDataReturned" class="col-12 mt-3">
                        <select
                          class="form-select custom-select custom-select mt-0"
                          v-model="sender.address"
                          @change="fullAddressInfo"
                        >
                          <option disabled selected value="null">
                            -- Select an address --
                          </option>
                          <option
                            v-for="option in addressOptions"
                            :key="option.format"
                            :value="option"
                          >
                            {{ option.suggestion }}
                          </option>
                        </select>
                      </div>
                    </section>

                    <section class="form-group row">
                      <div class="col-12 d-none">
                        <label for="ADDRESS1">Address Line 1</label>
                      </div>
                      <div class="col-12">
                        <b-form-input
                          placeholder="Address Line 1"
                          v-model="$v.sender.address_1.$model"
                          :state="validateState('sender', 'address_1')"
                          @change="touchField($v.sender.address_1)"
                        ></b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.sender.address_1.$dirty &&
                              !$v.sender.address_1.required
                          "
                        >
                          Field is required
                        </div>
                      </div>
                    </section>

                    <section class="form-group row">
                      <div class="col-12 d-none">
                        <label for="ADDRESS2">Address Line 2</label>
                      </div>
                      <div class="col-12">
                        <b-form-input
                          placeholder="Address Line 2"
                          v-model="sender.address_2"
                        ></b-form-input>
                      </div>
                    </section>

                    <section class="form-group row">
                      <div class="col-12 d-none">
                        <label for="ADDRESS3">Address Line 3</label>
                      </div>
                      <div class="col-12">
                        <b-form-input
                          placeholder="Address Line 3"
                          v-model="sender.address_3"
                        ></b-form-input>
                      </div>
                    </section>

                    <section v-show="isIe" class="form-group row">
                      <div class="col-12 d-none">
                        <label for="ADDRESS3">Address Line 4</label>
                      </div>
                      <div class="col-12 ">
                        <b-form-input
                          placeholder="Address Line 4"
                          v-model="sender.address_4"
                        ></b-form-input>
                      </div>
                    </section>

                    <section class="form-group row">
                      <div class="col-12 d-none">
                        <label v-if="!isIe" for="POSTCODE">Postcode</label>
                        <label v-if="isIe" for="EIRCODE">Eircode</label>
                      </div>
                      <div class="col-12">
                        <b-form-input
                          v-if="!isIe"
                          placeholder="Postcode"
                          v-model="$v.sender.postcode.$model"
                          :state="validateState('sender', 'postcode')"
                          @change="touchField($v.sender.postcode)"
                        ></b-form-input>
                        <b-form-input
                          v-if="isIe"
                          placeholder="Eircode"
                          v-model="$v.sender.postcode.$model"
                          :state="validateState('sender', 'postcode')"
                          @change="touchField($v.sender.postcode)"
                        ></b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="!$v.sender.postcode.minLength && !isIe"
                        >
                          Must be a valid Postcode
                        </div>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="!$v.sender.postcode.minLength && isIe"
                        >
                          Must be a valid Eircode
                        </div>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.sender.postcode.$dirty &&
                              !$v.sender.postcode.required
                          "
                        >
                          Field is required
                        </div>
                      </div>
                    </section>
                  </div>

                  <hr />

                  <p class="card-header fs-5 p-2">
                    <i class="material-icons icon-lg align-middle"
                      >perm_contact_calendar</i
                    >
                    <span class="ms-2">Gift Card Recipient</span>
                  </p>

                  <div class="card-body">
                    <section class="row form-group">
                      <div class="col-12 d-none">
                        <label>Gift</label>
                      </div>

                      <div class="col-12">
                        <b-col>
                          <b-form-radio
                            v-model="recipient.gift"
                            name="some-radios"
                            class="form-input d-table-cell align-bottom"
                            size="lg"
                            value="N"
                            ><label
                              class="form-check-label ms-2  mb-2 align-top"
                              >This gift is for me</label
                            ></b-form-radio
                          >
                          <span
                            v-if="
                              recipient.gift === 'N' &&
                                sender.firstname &&
                                sender.surname
                            "
                            class="fs-6 ms-2"
                          >
                            <button
                              role="button"
                              data-bs-toggle="modal"
                              data-bs-target="#gc_modal"
                              class="btn btn-dark mb-3"
                            >
                              View example
                              <i class="material-icons align-middle"
                                >keyboard_arrow_right</i
                              >
                            </button>
                          </span>
                          <br />
                          <b-form-radio
                            v-model="recipient.gift"
                            name="radio-size"
                            size="lg"
                            class="form-input d-table-cell align-bottom"
                            value="Y"
                            ><label
                              class="form-check-label ms-2  mb-2 align-top"
                              >This card is a gift for another person</label
                            ></b-form-radio
                          >
                        </b-col>
                      </div>
                    </section>

                    <section
                      v-show="recipient.gift === 'Y'"
                      class="row form-group"
                    >
                      <div class="col-12 d-none">
                        <label style="padding-top: 6%" for="input-small"
                          >Title</label
                        >
                      </div>

                      <div class="col-6 col-md-4 pt-2">
                        <b-form-select
                          class="form-select"
                          id="title-input-2"
                          name="title-input-2"
                          v-model.trim="$v.recipient.title.$model"
                          :options="titleOptions"
                          :state="validateState('recipient', 'title')"
                          @change="touchField(recipient.title)"
                        >
                        </b-form-select>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.recipient.title.$dirty &&
                              !$v.recipient.title.required
                          "
                        >
                          Please select a title.
                        </div>
                      </div>

                      <div class="col-12 d-none pt-2">
                        <label for="input-small">First Name</label>
                      </div>

                      <div class="col-6 col-md-4 pt-2">
                        <b-form-input
                          id="example-input-5"
                          v-model.trim="$v.recipient.firstname.$model"
                          placeholder="Firstname"
                          :state="validateState('recipient', 'firstname')"
                          @change="touchField(recipient.firstname)"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.recipient.firstname.$dirty &&
                              !$v.recipient.firstname.required
                          "
                        >
                          Field is required
                        </div>
                      </div>

                      <div class="col-12 d-none">
                        <label class="pt-2" for="input-small">Surname</label>
                      </div>

                      <div class="col-6 col-md-4 pt-2">
                        <b-form-input
                          id="example-input-2"
                          v-model="$v.recipient.surname.$model"
                          placeholder="Surname"
                          :state="validateState('recipient', 'surname')"
                          @change="touchField(recipient.surname)"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.recipient.surname.$dirty &&
                              !$v.recipient.surname.required
                          "
                        >
                          Field is required
                        </div>
                      </div>
                    </section>

                    <section
                      v-show="recipient.gift === 'Y'"
                      class="row form-group"
                    >
                      <div class="col-12 d-none">
                        <label for="EMAIL">Email address</label>
                      </div>
                      <div class="col-12">
                        <b-form-input
                          type="email"
                          placeholder="Email Address"
                          v-model.trim="$v.recipient.email.$model"
                          :state="validateState('recipient', 'email')"
                          @change="touchField(recipient.email)"
                        ></b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.recipient.email.$dirty &&
                              !$v.recipient.email.required
                          "
                        >
                          Field is required
                        </div>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="!$v.recipient.email.email"
                        >
                          E-mail is not valid
                        </div>
                      </div>
                    </section>

                    <section
                      v-show="recipient.gift === 'Y'"
                      class="row form-group"
                    >
                      <div class="col-12 d-none">
                        <label for="EMAILCONFIRM">Email address</label>
                      </div>
                      <div class="col-12">
                        <b-form-input
                          type="email"
                          placeholder="Confirm Email Address"
                          v-model.trim="$v.recipient.emailconfirm.$model"
                          :state="validateState('recipient', 'emailconfirm')"
                          @change="touchField(recipient.emailconfirm)"
                        ></b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.recipient.emailconfirm.$dirty &&
                              !$v.recipient.emailconfirm.required
                          "
                        >
                          Field is required
                        </div>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="!$v.recipient.emailconfirm.sameAs"
                        >
                          Email Address does not match
                        </div>
                      </div>
                    </section>

                    <section
                      v-show="recipient.gift === 'Y'"
                      class="row form-group"
                    >
                      <div class="col-12 d-none">
                        <label for="Message">Message from you</label>
                      </div>
                      <div class="col-12">
                        <b-form-textarea
                          rows="6"
                          class="mt-2"
                          id="input-7"
                          placeholder="Message from you"
                          v-model="recipient.message"
                        >
                        </b-form-textarea>
                      </div>
                    </section>

                    <section v-show="recipient.gift === 'Y'">
                      <div class="row form-group">
                        <div class="col-12 col-md-6">
                          <span
                            v-if="recipient.firstname && recipient.surname"
                            class="fs-6 ms-0"
                          >
                            <button
                              role="button"
                              data-bs-toggle="modal"
                              data-bs-target="#gc_modal"
                              class="btn btn-dark mb-3"
                            >
                              View example
                              <i class="material-icons align-middle"
                                >keyboard_arrow_right</i
                              >
                            </button>
                          </span>
                          <br />
                          <b-form-checkbox
                            id="checkbox-1"
                            v-model="recipient.scheduled"
                            name="scheduled_date"
                            value="true"
                            unchecked-value="false"
                          >
                            <label
                              class="form-check-label ms-2  mb-2 align-top"
                              for="checkbox-1"
                              >Send Gift Card at a later date?</label
                            >
                          </b-form-checkbox>
                        </div>
                        <div class="col-12 col-md-6">
                          <b-form-datepicker
                            v-if="recipient.scheduled === 'true'"
                            reset-button
                            reset-value=""
                            locale="en"
                            :min="min"
                            close-button
                            v-model.trim="$v.recipient.scheduled_pretty.$model"
                            :state="
                              validateState('recipient', 'scheduled_pretty')
                            "
                            @change="touchField($v.recipient.scheduled_pretty)"
                            class="mt-4"
                            aria-describedby="input-13-live-feedback"
                          ></b-form-datepicker>
                          <div
                            class="alert alert-warning my-2"
                            v-if="futureOrder"
                          >
                            This payment type requires the Gift Card to be sent
                            at a later date (min. 14 days ahead)
                          </div>
                          <div
                            class="alert alert-danger mb-0"
                            v-if="
                              $v.recipient.scheduled_pretty.$dirty &&
                                !$v.recipient.scheduled_pretty.required
                            "
                          >
                            Field is required
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>

                  <hr />

                  <p class="card-header fs-5 p-2">
                    <i class="material-icons icon-lg align-middle"
                      >card_giftcard</i
                    >
                    <span class="ms-2">Select a Design</span>
                  </p>
                  <div
                    v-show="
                      card.ccpayment !== null &&
                        $v.card.ccpayment.between &&
                        $v.card.ccpayment.$model !== ''
                    "
                    class="card-body"
                  >
                    <section class="row form-group">
                      <div class="col-12 d-none">
                        <label for="CARDVALUE">Card value in </label>
                      </div>
                      <div class="col-12">
                        <div>
                          <div id="BrochureFanPanel">
                            <div class="card shadow border-0 rounded-0 mb-0">
                              <div class="card-body">
                                <section class="brochure-display">
                                  <div class="row">
                                    <div
                                      v-for="img in giftcardDesigns"
                                      :key="img.cardDesign"
                                      class="w-30"
                                    >
                                      <img
                                        :src="img.url"
                                        alt="Gift Card"
                                        v-on:click="
                                          selectedGiftCard(img.cardDesign)
                                        "
                                        class="w-100 pb-3 px-2"
                                        :class="{
                                          chosenCard:
                                            card_design === img.cardDesign,
                                        }"
                                      />
                                    </div>
                                  </div>
                                </section>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>

                  <hr />

                  <p class="card-header p-2 fs-5">
                    <i class="material-icons icon-lg align-middle"
                      >credit_card</i
                    >
                    <span class="ms-2">Payment Information</span>
                  </p>

                  <div
                    class="card-body"
                    v-show="
                      card.ccpayment !== null &&
                        $v.card.ccpayment.between &&
                        $v.card.ccpayment.$model !== ''
                    "
                  >
                    <div class="bg-grey p-3">
                      <h4 class="h4 mt-0">
                        Total to pay
                        <strong
                          >{{ GENERAL_CONFIG.CURRENCY
                          }}{{ card.ccpayment }}</strong
                        >
                      </h4>
                    </div>

                    <!-- <div v-if="ref === '.com'">
                      <b-form-radio
                        v-model="paymentType"
                        name="some-radios-pt"
                        id="some-radios-pt"
                        size="lg"
                        class="form-input d-table-cell align-bottom"
                        value="Card"
                        ><label class="form-check-label ms-2  mb-2 align-top" for="some-radios-pt">
                        Pay by Credit or Debit Card
                        </label>
                        </b-form-radio
                      >
                    <br /> -->
                    <!-- Hidden 29/04/24 As Amex API was expecting masked date -->
                    <!-- <b-form-radio
                        v-model="paymentType"
                        name="radio-size-pt"
                        id="radio-size-pt"
                        class="form-input d-table-cell align-bottom"
                        size="lg"
                        value="AMEX"
                        ><label class="form-check-label ms-2  mb-2 align-top" for="radio-size-pt">
                        Pay by Bank Transfer
                        </label>
                        </b-form-radio
                      > -->
                    <!-- </div> -->
                    <button
                      v-if="
                        !clicked.includes('Submitted') && paymentType === 'Card'
                      "
                      @click.prevent="onSubmit()"
                      data-condition="test"
                      data-bs-toggle="modal"
                      data-bs-target="#myLargeModalLabel"
                      class="btn btn-success btn-block btn-xl mt-5"
                      style="text-align: center"
                    >
                      Pay By Debit or Credit Card
                    </button>

                    <b-alert
                      v-if="formInvalid"
                      class="mt-2"
                      style="text-align: center"
                      variant="danger"
                      show
                      >Please complete all required fields</b-alert
                    >
                  </div>
                  <div class="mt-3 text-center" v-if="paymentType === 'AMEX'">
                    <div>
                      <strong> Click the Bank Transfer box below</strong><br />
                    </div>
                    <button
                      type="button"
                      style="
                        height: 61px;
                        width: 317px;
                        background-image: url(https://icm.aexp-static.com/Internet/IMDC/paywithbank/images/pwb-desktop-dark.png);
                        border: none;
                      "
                      @click.prevent="onSubmit()"
                    />
                  </div>
                </div>
              </b-form>

              <div v-if="amexComplete">
                <!--AMEX ERROR-->
                <b-alert
                  class="mt-2"
                  style="text-align: center"
                  variant="danger"
                  :show="amexStatus === 'ERROR'"
                >
                  <div class="vtd-alert vtd-alert-global vtd-has-icon vtd-mb-5">
                    <div class="media-body">
                      <i
                        class="material-icons vtd-pr-3 vtd-align-middle text-danger"
                        >&#xE002;</i
                      >
                      <span class="text-danger">
                        <span class="material-icons report" aria-hidden="true"
                          >report</span
                        >
                        Unfortunately your bank has not authorised the payment.
                        <br /><br />
                        Please pay via another method or contact your bank for
                        details.
                      </span>
                    </div>
                  </div>
                </b-alert>
                <!-- AMEX SUCCESS -->
                <b-alert
                  class="mt-2"
                  variant="success"
                  :show="amexStatus === 'AMEX_COMPLETE'"
                >
                  <div class="success">
                    Thank you.<br /><br />
                    Your payment for <strong>{{ amexData.amount }}</strong> has
                    been received. <br /><br />
                    You will receive an email confirmation shortly.<br /><br />
                    For your reference your Order Number is
                    <strong>{{ amexData.giftcardReference }}</strong
                    ><br /><br />
                    Your Gift card number is
                    <strong>{{ amexData.giftcardNumber }}</strong>
                  </div>
                </b-alert>
                <!--AMEX PENDING -->
                <b-alert
                  class="mt-2"
                  variant="warning"
                  :show="amexStatus === 'AMEX_IN_PROGRESS'"
                >
                  <div class="warning">
                    <i
                      class="material-icons vtd-pr-3 vtd-align-middle text-danger"
                      >&#xE002;</i
                    >
                    Your payment is taking a little longer than expected to
                    authorise.
                    <br /><br />
                    We will send you an email once confirmed.
                    <br /><br />
                    Thank you
                    <br /><br />
                    Your reference is: <strong>{{ amexData.order_id }}</strong>
                  </div>
                </b-alert>
              </div>
            </div>

            <div class="col-12">
              <p class="fs-5 m-2 ms-2">Terms &amp; Conditions</p>
              <small v-if="!isIe" class="text-muted m-sm d-block">
                Trailfinders Gift Cards are valid indefinitely and can only be
                redeemed against products and services paid direct to
                Trailfinders Ltd. Trailfinders Gift Cards are 100%
                non-refundable immediately following purchase. Trailfinders Gift
                Cards cannot be exchanged for cash. Any unused credit will
                remain on the Gift Card and can be used towards payment of
                future travels. Trailfinders Gift Card monies are protected in
                the Trailfinders Trust Account.
              </small>
              <small v-else class="text-muted m-sm d-block">
                Trailfinders Gift Cards are valid indefinitely and can only be
                redeemed against products and services paid direct to
                Trailfinders Ireland Ltd. Trailfinders Gift Cards are 100%
                non-refundable immediately following purchase. Trailfinders Gift
                Cards cannot be exchanged for cash. Any unused credit will
                remain on the Gift Card and can be used towards payment of
                future travels. Trailfinders Gift Card monies are protected in
                the Trailfinders Trust Account.
              </small>
            </div>
          </section>
        </div>

        <!-- Giftcard Modal Pop UP -->
        <div
          class="modal"
          id="gc_modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="preview"
          aria-hidden="true"
          size="xl"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content" id="gc_preview">
              <div class="modal-header">
                <h4 class="modal-title mt-2" id="myModalLabel">
                  Gift Card Email Preview
                </h4>
                <button
                  type="button"
                  class="btn-close px-3"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <!-- EMAIL CONTENT -->
                <table
                  cellpadding="0"
                  cellspacing="0"
                  align="center"
                  style="border-collapse: collapse; margin: 0 auto"
                  class="table-wrapper"
                >
                  <tbody>
                    <tr>
                      <td width="300">
                        <table
                          id="screen"
                          border="0"
                          cellpadding="0"
                          cellspacing="0"
                          width="100%"
                          style="margin: 0 auto; max-width: 600px"
                          class="wrapper"
                        >
                          <tbody>
                            <tr>
                              <!-- max-width: 350px; in TD below -->
                              <td
                                align="center"
                                class="maxWidth"
                                valign="top"
                                style="padding-top: 30px; padding-bottom: 30px"
                              >
                                <!-- HEADER TABLE -->
                                <table
                                  border="0"
                                  cellpadding="0"
                                  cellspacing="0"
                                  width="100%"
                                  style="
                                    background-color: #2b2b2b;
                                    border-radius: 15px 15px 0 0;
                                  "
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        class="padding"
                                        style="padding: 30px !important"
                                      >
                                        <table
                                          border="0"
                                          cellpadding="0"
                                          cellspacing="0"
                                          width="100%"
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                width="60%"
                                                align="left"
                                                valign="top"
                                                style="
                                                  text-align: left;
                                                  width: 60%;
                                                "
                                              >
                                                <a
                                                  href="http://www.trailfinders.com"
                                                  target="_blank"
                                                  style="border: none"
                                                >
                                                  <img
                                                    alt="Trailfinders"
                                                    s_org_src=""
                                                    src="https://www.trailfinders.com/graphics/email/client/logo-trailfinders-light.jpg"
                                                    class="img-responsive"
                                                    style="
                                                      max-width: 310px;
                                                      border: none;
                                                      outline: none;
                                                      display: block;
                                                    "
                                                  />
                                                </a>
                                              </td>
                                              <td
                                                width="15%"
                                                align="left"
                                                valign="top"
                                                style="
                                                  text-align: left;
                                                  width: 15%;
                                                "
                                              >
                                                <p>&nbsp;</p>
                                              </td>
                                              <td
                                                width="25%"
                                                align="right"
                                                valign="top"
                                                style="
                                                  text-align: right;
                                                  width: 25%;
                                                "
                                              >
                                                <a
                                                  href="https://uk.trustpilot.com/review/www.trailfinders.com"
                                                  target="_blank"
                                                  style="border: none"
                                                  rel="noopener"
                                                >
                                                  <img
                                                    alt="Trustpilot Reviews"
                                                    src="https://www.trailfinders.com/graphics/email/client/logo-trustpilot-review-light.jpg"
                                                    class="img-responsive"
                                                    style="
                                                      border: none;
                                                      outline: none;
                                                      display: block;
                                                    "
                                                  />
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                                <!-- /HEADER TABLE -->
                                <table
                                  cellpadding="0"
                                  cellspacing="0"
                                  style="
                                    border-collapse: collapse;
                                    background: #f1f1f1;
                                  "
                                  width="100%"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        class="padding"
                                        style="padding: 30px !important"
                                      >
                                        <p
                                          v-if="recipient.gift === 'N'"
                                          style="
                                            font-family: 'Trebuchet MS', Verdana,
                                              'sans-serif';
                                            font-size: 16px;
                                          "
                                        >
                                          Thank you for your purchase
                                          {{ sender.firstname }}
                                          {{ sender.surname }}.<br /><br />
                                          Your Trailfinders reference is
                                          <strong>ABC123</strong> and the Gift
                                          Card details are displayed below.
                                        </p>
                                        <p
                                          v-if="recipient.gift === 'Y'"
                                          style="
                                            font-family: 'Trebuchet MS', Verdana,
                                              sans-serif;
                                            font-size: 16px;
                                          "
                                        >
                                          <strong>To: </strong>
                                          {{ recipient.firstname }}
                                          {{ recipient.surname }}<br /><br />
                                          <strong>From:</strong>
                                          {{ sender.firstname }}
                                          {{ sender.surname }}<br /><br />
                                          {{ recipient.message }}
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                                <table
                                  cellpadding="0"
                                  cellspacing="0"
                                  style="
                                    border-collapse: collapse;
                                    margin: 0;
                                    padding: 0;
                                  "
                                  width="100%"
                                >
                                  <tbody>
                                    <tr>
                                      <td width="130">
                                        <img
                                          class="img1"
                                          style="
                                            border: none;
                                            outline: none;
                                            display: block;
                                          "
                                          :src="
                                            'https://www.trailfinders.com/graphics/giftcard/gift-card-bkg_01' +
                                              imageDesign +
                                              '.jpg'
                                          "
                                          alt="Trailfinders Gift Card"
                                        />
                                      </td>
                                      <td width="350">
                                        <img
                                          class="img2"
                                          style="
                                            border: none;
                                            outline: none;
                                            display: block;
                                          "
                                          :src="
                                            'https://www.trailfinders.com/graphics/giftcard/gift-card-bkg_02' +
                                              imageDesign +
                                              '.jpg'
                                          "
                                          alt="Trailfinders Gift Card"
                                        />
                                      </td>
                                      <td width="120">
                                        <img
                                          class="img3"
                                          style="
                                            border: none;
                                            outline: none;
                                            display: block;
                                          "
                                          :src="
                                            'https://www.trailfinders.com/graphics/giftcard/gift-card-bkg_03' +
                                              imageDesign +
                                              '.jpg'
                                          "
                                          alt="Trailfinders Gift Card"
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <img
                                          class="img4"
                                          style="
                                            border: none;
                                            outline: none;
                                            display: block;
                                          "
                                          :src="
                                            'https://www.trailfinders.com/graphics/giftcard/gift-card-bkg_04' +
                                              imageDesign +
                                              '.jpg'
                                          "
                                          alt="Trailfinders Gift Card"
                                        />
                                      </td>
                                      <td
                                        align="right"
                                        :background="
                                          'https://www.trailfinders.com/graphics/giftcard/' +
                                            img5a +
                                            ',dpr_auto,q_auto/gift-card-bkg_05' +
                                            imageDesign +
                                            '.jpg'
                                        "
                                        bgcolor="#2b2b2b"
                                        valign="top"
                                        v-bind:style="{
                                          backgroundImage:
                                            'url(https://www.trailfinders.com/graphics/giftcard/gift-card-bkg_05' +
                                            imageDesign +
                                            '.jpg)',
                                        }"
                                      >
                                        <span class="modalText">{{
                                          GENERAL_CONFIG.CURRENCY
                                        }}</span>
                                        <!-- MONEY VALUE BELOW -->
                                        <span class="modalPayText">{{
                                          card.ccpayment
                                        }}</span>
                                        <br />
                                        <!-- ID VALUE BELOW -->

                                        <span class="modalCardNo"
                                          >1234567812345678</span
                                        >
                                      </td>
                                      <td>
                                        <img
                                          class="img6"
                                          style="
                                            border: none;
                                            outline: none;
                                            display: block;
                                          "
                                          :src="
                                            'https://www.trailfinders.com/graphics/giftcard/gift-card-bkg_06' +
                                              imageDesign +
                                              '.jpg'
                                          "
                                          alt="Trailfinders Gift Card"
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <img
                                          class="img7"
                                          style="
                                            border: none;
                                            outline: none;
                                            display: block;
                                          "
                                          :src="
                                            'https://www.trailfinders.com/graphics/giftcard/gift-card-bkg_07' +
                                              imageDesign +
                                              '.jpg'
                                          "
                                          alt="Trailfinders Gift Card"
                                        />
                                      </td>
                                      <td>
                                        <img
                                          class="img8"
                                          style="
                                            border: none;
                                            outline: none;
                                            display: block;
                                          "
                                          :src="
                                            'https://www.trailfinders.com/graphics/giftcard/gift-card-bkg_08' +
                                              imageDesign +
                                              '.jpg'
                                          "
                                          alt="Trailfinders Gift Card"
                                        />
                                      </td>
                                      <td>
                                        <img
                                          class="img9"
                                          style="
                                            border: none;
                                            outline: none;
                                            display: block;
                                          "
                                          :src="
                                            'https://www.trailfinders.com/graphics/giftcard/gift-card-bkg_09' +
                                              imageDesign +
                                              '.jpg'
                                          "
                                          alt="Trailfinders Gift Card"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <!-- MAIN BODY TABLE -->
                                <table
                                  border="0"
                                  cellpadding="0"
                                  cellspacing="0"
                                  width="100%"
                                  style="
                                    background-color: #f1f1f1;
                                    border-radius: 0 0 15px 15px;
                                  "
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="left"
                                        class="padding"
                                        id="text-body"
                                        style="padding: 30px !important"
                                      >
                                        <h1
                                          style="
                                            font-family: 'Trebuchet MS', Verdana,
                                              'sans-serif';
                                            font-size: 30px;
                                            margin-top: 0;
                                          "
                                        >
                                          Your gift of Travel
                                          <span style="color: #555"
                                            >- it's easy to use</span
                                          >
                                        </h1>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          style="border-collapse: collapse"
                                          width="100%"
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                valign="top"
                                                style="padding: 0"
                                                class="mob-stack"
                                              >
                                                <img
                                                  style="
                                                    border: none;
                                                    outline: none;
                                                    display: block;
                                                    width: 100%;
                                                    max-width: 80px;
                                                    height: auto;
                                                    float: left;
                                                    padding: 2% 2% 0 2%;
                                                  "
                                                  src="https://mailimages.trailfinders.com/e-gift-card/icon_in-store.gif"
                                                  alt="In Store"
                                                />
                                                <p
                                                  style="
                                                    font-family: 'Trebuchet MS',
                                                      Verdana, 'sans-serif';
                                                    font-size: 16px;
                                                  "
                                                >
                                                  <strong
                                                    >In store or on the
                                                    phone</strong
                                                  ><br />
                                                  Valid indefinitely<br />
                                                  Simply give your gift card
                                                  number to your consultant
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>

                                        <table
                                          style="border-collapse: collapse"
                                          class="has-icon"
                                          cellpadding="0"
                                          cellspacing="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td style="padding: 8px 0">
                                              <p
                                                style="
                                                  font-family: 'Trebuchet MS',
                                                    Verdana, 'sans-serif';
                                                  font-size: 16px;
                                                "
                                              >
                                                Whether you're looking for a
                                                barefoot beach escape or a chic
                                                city break, a carefree fly drive
                                                or the ultimate round the world
                                                adventures, let Trailfinders
                                                take care of all your travel
                                                needs. From worldwide flights to
                                                hotels, tours, car hire and
                                                everything in between, you can
                                                look forward to exceptional
                                                value on every aspect of your
                                                holiday.
                                              </p>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <!-- /MAIN BODY TABLE -->

                                <!-- PRINT GIFT CARD TABLE -->
                                <table
                                  border="0"
                                  cellpadding="0"
                                  cellspacing="0"
                                  width="100%"
                                  style="background-color: #f1f1f1"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="left"
                                        class="padding"
                                        id="text-body"
                                        style="padding: 30px !important"
                                      >
                                        <table
                                          style="
                                            background: #fff;
                                            border-collapse: collapse;
                                          "
                                          class="has-icon"
                                          cellpadding="0"
                                          cellspacing="0"
                                          width="100%"
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                width="50%"
                                                style="padding: 15px"
                                                class="mob-stack"
                                              >
                                                <img
                                                  style="
                                                    display: block;
                                                    border: none;
                                                    outline: none;
                                                    float: left;
                                                    padding: 15px;
                                                  "
                                                  src="https://mailimages.trailfinders.com/e-gift-card/icon_print.gif"
                                                  alt="Contact Us"
                                                />
                                                <p
                                                  style="
                                                    padding: 5px 0;
                                                    font-family: 'Trebuchet MS',
                                                      Verdana, 'sans-serif';
                                                    font-size: 18px;
                                                  "
                                                >
                                                  <strong
                                                    >Print this gift
                                                    card</strong
                                                  >
                                                </p>
                                                <p
                                                  style="
                                                    padding: 5px 0;
                                                    font-family: 'Trebuchet MS',
                                                      Verdana, 'sans-serif';
                                                    font-size: 16px;
                                                  "
                                                >
                                                  Most email clients will
                                                  automatically print out a
                                                  physical card and wallet when
                                                  you click the print option.
                                                </p>
                                              </td>
                                              <td
                                                style="padding: 15px"
                                                class="mob-stack"
                                              >
                                                <img
                                                  style="
                                                    border: none;
                                                    outline: none;
                                                    display: block;
                                                    width: 100%;
                                                    max-width: 300px;
                                                    height: auto;
                                                  "
                                                  src="https://mailimages.trailfinders.com/e-gift-card/print-mock.gif"
                                                  alt="Trailfinders Gift Card Wallet"
                                                />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <!-- PRINT GIFT CARD TABLE -->
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                <!-- END EMAIL CONTENT -->
              </div>
            </div>
          </div>
        </div>

        <!-- Payment iFrame CONTENT -->
        <div
          id="myLargeModalLabel"
          class="modal bd-example-modal-lg"
          tabindex="-1"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          role="dialog"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <p class="modal-title fs-5" id="exampleModalLongTitle">
                  Giftcard Payment
                </p>
                <button
                  type="button"
                  class="btn-close px-2"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <section
                  v-if="barclaysError || !isConnected"
                  class="rd-flex justify-content-center ml-5 mb-3"
                >
                  <div class="col-xs-10 col-md-10 alert alert-warning ml-5">
                    <p>
                      Unfortunately we have not been able to process your
                      request.
                      <br />
                      To complete your order, please call Trailfinders Gift Card
                      department on
                      <strong>{{ GENERAL_CONFIG.TELEPHONE }}</strong>
                    </p>
                  </div>
                </section>
                <div
                  v-else-if="isLoading"
                  class="d-flex justify-content-center mb-3"
                >
                  <b-spinner label="Loading..."></b-spinner>
                </div>
                <b-alert
                  v-else-if="formInvalidModal"
                  class="mt-2"
                  style="text-align: center"
                  variant="danger"
                  show
                  >Please complete all required fields</b-alert
                >
                <div v-else class="col-xs-12 col-md-12">
                  <section v-if="paymentError" class="row form-group m-t-md">
                    <div class="col-xs-12 col-md-12 alert alert-warning">
                      <p>
                        Unfortunately we have not been able to process your
                        request.
                        <br />
                        Your Debit/Credit card has not been charged.
                        <br />
                        <br />
                        If the issue persists please call Trailfinders Gift
                        Cards department on
                        <strong>{{ GENERAL_CONFIG.TELEPHONE }}</strong>
                      </p>
                    </div>
                  </section>

                  <section
                    v-else-if="paymentSuccess"
                    class="row form-group m-t-md"
                  >
                    <div class="col-xs-12 col-md-12 alert alert-secondary">
                      <p>
                        Your payment for
                        <strong class="font-weight-bold"
                          >{{ GENERAL_CONFIG.CURRENCY
                          }}{{ card.ccpayment }}</strong
                        >
                        has been successful.
                      </p>
                      <!-- SF and emails OK -->
                      <div v-if="giftcard.emails === 'OK'">
                        <p>
                          A receipt has been sent to
                          <strong class="font-weight-bold">{{
                            sender.email
                          }}</strong
                          >.
                          <span v-if="recipient.gift === 'N'" class="p-b-sm">
                            It includes the gift card details and how to redeem
                            it.
                          </span>
                          <span
                            v-if="
                              recipient.gift === 'Y'
                              "
                            class="p-b-sm"
                          >
                            An email has also been sent to
                            <strong class="font-weight-bold">{{
                              recipient.email
                            }}</strong>
                            with details of the gift card including how to
                            redeem it.
                          </span>
           
                        </p>
                      </div>
                      <div
                        v-if="
                          giftcard.status === 'OK' &&
                            !hideFrom(sender.email, recipient.email)
                        "
                      >
                        <p>
                          For your reference the gift card number is
                          <strong class="font-weight-bold">{{
                            giftcard.giftcardnumber
                          }}</strong>
                          and the booking reference is
                          <strong class="font-weight-bold">{{
                            giftcard.bookno
                          }}</strong>
                          <br />If you require any assistance please contact
                          Trailfinders Gift Cards on
                          <strong class="font-weight-bold">{{
                            GENERAL_CONFIG.TELEPHONE
                          }}</strong>
                        </p>
                      </div>

                      <!-- SF or emails error -->
                      <div
                        v-if="
                          giftcard.status !== 'OK' || giftcard.emails !== 'OK'
                        "
                      >
                        <p class="mb-1">
                          <b-icon
                            icon="exclamation-triangle-fill"
                            variant="dark"
                            class="h5 my-0"
                          ></b-icon>
                          Unfortunately we have not been able to complete your
                          order.
                        </p>
                        <p
                          class="mb-1 pl-4 text-small"
                          v-if="giftcard.status !== 'OK'"
                        >
                          &bullet; Your gift card number could not be confirmed.
                        </p>
                        <p
                          class="mb-1 pl-4 text-small"
                          v-if="giftcard.emails !== 'OK'"
                        >
                          There was a problem sending the gift card details by
                          email.
                        </p>
                        <p class="mb-1">
                          To complete your order, please call Trailfinders Gift
                          Card department on
                          <strong class="font-weight-bold">{{
                            GENERAL_CONFIG.TELEPHONE
                          }}</strong>
                        </p>
                      </div>
                    </div>
                  </section>
                  <section
                    v-if="barclaysModalError"
                    class="rd-flex justify-content-center ml-5 mb-3"
                  >
                    <div class="col-xs-10 col-md-10 alert alert-warning ml-5">
                      <p>
                        Unfortunately we have not been able to process your
                        request.
                        <br />
                        To complete your order, please call Trailfinders Gift
                        Card department on
                        <strong>{{ GENERAL_CONFIG.TELEPHONE }}</strong>
                      </p>
                    </div>
                  </section>
                  <iframe v-else id="payment-frame" :src="barclaysUrl"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END Payment iFrame CONTENT -->
      </section>
    </main>
  </section>
</template>

<script>
import moment from "moment";
import { validationMixin } from "vuelidate";
import { countryCodes } from "../../assets/countryCodes";
import {
  required,
  email,
  minLength,
  sameAs,
  requiredIf,
  between,
  numeric,
} from "vuelidate/lib/validators";
import {
  fetchAddressInfo,
  getFullAddressInfo,
  amexButtonPayment,
  amexUpdate,
} from "../../../src/services/api";
import Autoaddress from "@autoaddress.ie/autoaddress-vue/src/Autoaddress";

export default {
  components: {
    Autoaddress,
  },
  sockets: {
    connect: function() {
      this.isConnected = true;
      this.socketId = this.$socket.id;
      // console.log("socket connected");
    },
    begin: function() {
      // console.log(`logging socket resp - ${data}`)
    },
    beginResponse: function(resp) {
      if (resp && resp.paymentRedirectUrl) {
        this.barclaysStage1 = false;
        this.barclaysStage2 = true;
        this.barclaysUrl = resp.paymentRedirectUrl;
        if (this.barclaysUrl !== "") {
          this.barclaysError = false;
          this.isLoading = false;
        }
      } else {
        this.barclaysError = true;
        this.isLoading = false;
      }
    },
    finished: function(finishedResponse) {
      if (finishedResponse && finishedResponse.success === true) {
        this.giftcard = finishedResponse.result;
        this.barclaysStage1 = false;
        this.barclaysStage2 = false;
        this.paymentSuccess = true;
      } else if (finishedResponse && finishedResponse.error) {
        this.barclaysStage1 = false;
        this.barclaysStage2 = false;
        this.paymentError = true;
        this.isLoading = false;
      } else {
        this.barclaysError = true;
        this.isLoading = false;
      }
    },
  },
  mixins: [validationMixin],

  data() {
    return {
      data: {},
      sfData: {},
      card_design: "a",
      barclaysModalError: false,
      barclaysStage1: true,
      paymentModal: false,
      barclaysError: false,
      barclaysStage2: false,
      formInvalid: false,
      isConnected: false,
      barclaysUrl: "",
      isLoading: true,
      giftcard: {},
      giftcardDesigns: [
        {
          cardDesign: "a",
          url: "https://cdn.trailfinders.com/pdqb3jz61q_giftcard-default.jpg",
        },
        {
          cardDesign: "b",
          url: "https://cdn.trailfinders.com/kkgsmpnzlr_giftcard-fireworks.jpg",
        },
        {
          cardDesign: "c",
          url: "https://cdn.trailfinders.com/nudoxmpcza_giftcard-present.jpg",
        },
        {
          cardDesign: "d",
          url: "https://cdn.trailfinders.com/t1lriqf0yr_giftcard-beach.jpg",
        },
        {
          cardDesign: "e",
          url: "https://cdn.trailfinders.com/pt7qrgnoc2_giftcard-globe.jpg",
        },
        {
          cardDesign: "f",
          url: "https://cdn.trailfinders.com/mebdkxx6ov_giftcard-island.jpg",
        },
      ],
      currency: "GBP",
      paymentSuccess: false,
      paymentError: false,
      cardvalue: null,
      addressDataReturned: false,
      addressFound: false,
      isIe: false,
      site: "",
      ref: ".com",
      min: moment()
        .add(1, "day")
        .toDate(),
      addressOptions: null,
      formInvalidModal: false,
      addressSelected: null,
      img5a: "",
      imageDesign: "_a",
      clicked: [],
      countryCodes: countryCodes,
      intAddress: "",
      sender: {
        title: null,
        firstname: "",
        surname: "",
        phone: "",
        email: "",
        emailconfirm: "",
        address: null,
        address_1: "",
        address_2: "",
        address_3: "",
        postcode: "",
        postcodeSearch: "",
        countryCode: null,
      },
      recipient: {
        title: null,
        firstname: "",
        surname: "",
        email: "",
        emailconfirm: "",
        gift: "N",
        scheduled: "false",
        scheduled_pretty: null,
      },
      card: {
        ccpayment: null,
      },
      GENERAL_CONFIG: {
        CURRENCY: "£",
      },
      titleOptions: [
        { text: "Select Title", value: null },
        "Mrs",
        "Miss",
        "Ms",
        "Mr",
        "Dr",
        "Other",
      ],
      meta: {
        loaded: true,
      },
      date: null,
      paymentType: "Card",
      futureOrder: false,
      amexComplete: false,
      amexData: {
        status: null,
        amount: null,
        order_id: null,
        giftcardNumber: null,
        giftcardReference: null,
      },
      amexStatus: null,
    };
  },
  validations: {
    sender: {
      title: {
        required: required,
      },
      firstname: {
        required: required,
      },
      surname: {
        required: required,
      },
      phone: {
        required: required,
        numeric: numeric,
        minLength: minLength(5),
      },
      email: {
        required: required,
        email: email,
        minLength: minLength(3),
      },
      emailconfirm: {
        required: required,
        email: email,
        minLength: minLength(3),
        sameAs: sameAs(function() {
          return this.sender.email;
        }),
      },
      address_1: {
        required: required,
      },
      postcode: {
        required: required,
        minLength: minLength(4),
      },
      countryCode: {
        required: requiredIf(function() {
          return this.intAddress === "yes";
        }),
      },
    },
    recipient: {
      title: {
        required: requiredIf(function() {
          return this.recipient.gift === "Y";
        }),
      },
      firstname: {
        required: requiredIf(function() {
          return this.recipient.gift === "Y";
        }),
      },
      surname: {
        required: requiredIf(function() {
          return this.recipient.gift === "Y";
        }),
      },
      email: {
        required: requiredIf(function() {
          return this.recipient.gift === "Y";
        }),
        email: email,
        minLength: minLength(3),
      },
      emailconfirm: {
        required: requiredIf(function() {
          return this.recipient.gift === "Y";
        }),
        email: email,
        minLength: minLength(3),
        sameAs: sameAs("email"),
      },
      scheduled_pretty: {
        required: requiredIf(function() {
          return this.recipient.scheduled === "true";
        }),
      },
    },
    card: {
      ccpayment: {
        required: required,
        between: between(10, 10000),
      },
    },
  },
  watch: {
    async $route(to) {
      // Watching for AMEX route change
      if (to.name === "amex") {
        this.amexComplete = true;
        const payload = {
          status: this.$route.query.status,
          request_id: this.$route.query.request_id,
          transaction_details: this.$route.query.transaction_details,
        };

        let result = await amexUpdate(payload);

        if (result.error) {
          this.errorLoadingData = true;
          return;
        }
        this.amexData = result.data;
        if (this.amexData.status) {
          this.amexStatus = this.amexData.status;
        }
      }
    },
    paymentType(type) {
      if (type === "AMEX") {
        this.min = this.futureOrderMin;
        this.recipient.scheduled_pretty = null;
        this.futureOrder = true;
      } else {
        this.futureOrder = false;
        this.min = moment()
          .add(1, "day")
          .toDate();
      }
    },
  },
  computed: {
    futureOrderMin() {
      return moment()
        .add(14, "day")
        .toDate();
    },
  },
  methods: {
    loadAmexButton() {
      // Need to build sfData Object so we can save it on the Amex record for sending emails later
      this.buildSFData("AMEX");
      this.data.giftcardData = this.sfData;
      amexButtonPayment(this.data, this.ref);
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    buildSFData(payment_type = "CRD") {
      this.sfData.card = {};
      this.sfData.card_design = this.card_design;
      this.sfData.card.payment_type = payment_type;
      this.sfData.card.source = "website";
      this.sfData.currency = this.currency;
      this.sfData.card.ccpayment = parseInt(this.card.ccpayment);
      this.sfData.card.cardvalid = true;
      this.sfData.cardvalue = parseInt(this.card.ccpayment);
      this.sfData.sender = {};
      this.sfData.quantity = 1;
      this.sfData.uuid = this.guid();
      this.sfData.site = this.site;
      this.sfData.sender.title = this.sender.title;
      this.sfData.sender.firstname = this.sender.firstname
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "");
      this.sfData.sender.surname = this.sender.surname
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "");
      this.sfData.sender.phone = this.sender.phone;
      this.sfData.sender.email = this.sender.email;
      this.sfData.sender.emailconfirm = this.sender.emailconfirm;
      this.sfData.sender.address_1 = this.sender.address_1;
      this.sfData.sender.address_2 = this.sender.address_2;
      this.sfData.sender.address_3 = this.sender.address_3;
      this.sfData.sender.address_4 = "";
      this.sfData.sender.postcode = this.sender.postcode;
      this.sfData.sender.eircode = "";

      if (this.isIe) {
        this.sfData.sender.postcode = "IRELAND";
        this.sfData.sender.eircode = this.sender.postcode;
        if (this.sfData.sender.address_4) {
          this.sfData.sender.address_4 = this.sender.address_4;
        }
      }
      this.sfData.recipient = {};
      if (this.recipient.gift === "N") {
        this.sfData.recipient.title = "0";
        this.sfData.recipient.gift = "N";
        this.sfData.recipient.message = "";
      } else if (
        this.recipient.gift === "Y" &&
        this.recipient.scheduled === "false"
      ) {
        this.sfData.recipient.title = this.recipient.title;
        this.sfData.recipient.gift = this.recipient.gift;
        this.sfData.recipient.message = this.recipient.message;
        this.sfData.recipient.firstname = this.recipient.firstname;
        this.sfData.recipient.surname = this.recipient.surname;
        this.sfData.recipient.email = this.recipient.email;
        this.sfData.recipient.emailconfirm = this.recipient.emailconfirm;
      } else if (
        this.recipient.gift === "Y" &&
        this.recipient.scheduled === "true"
      ) {
        this.sfData.recipient.title = this.recipient.title;
        this.sfData.recipient.gift = this.recipient.gift;
        this.sfData.recipient.message = this.recipient.message;
        this.sfData.recipient.firstname = this.recipient.firstname
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");
        this.sfData.recipient.surname = this.recipient.surname
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");
        this.sfData.recipient.email = this.recipient.email;
        this.sfData.recipient.emailconfirm = this.recipient.emailconfirm;
        this.sfData.recipient.scheduled = true;
        this.sfData.recipient.scheduled_pretty = this.formatDate(
          this.recipient.scheduled_pretty
        );
        this.sfData.recipient.scheduled_date = new Date(
          this.recipient.scheduled_pretty
        ).toISOString();
      }
      this.sfData.staffid = "001";
      this.sfData.logname = "temp";
      const token = document.querySelector('meta[name="csrf-token"]').content;
      this.sfData.token = token;

      this.paymentSuccess = false;
      this.paymentError = false;
      this.payment_error_type = "";
    },
    async addressInfo(event) {
      event.preventDefault();
      this.addressFound = false;
      if (this.sender.postcodeSearch !== "") {
        let res = await fetchAddressInfo(this.sender.postcodeSearch, this.ref);
        if (res.error) {
          return res.error;
        } else {
          if (res.length > 0) {
            this.addressDataReturned = true;
            this.addressOptions = res;
          } else {
            this.addressFound = true;
          }
        }
      } else {
        this.addressFound = true;
      }
    },
    async fullAddressInfo(event) {
      this.addressFound = false;
      event.preventDefault();
      let res = await getFullAddressInfo(this.sender.address.format, this.ref);
      if (res.error) {
        return res.error;
      } else {
        this.addressDataReturned = false;
        this.addressFound = true;
        for (let i = 0; i < res.length; i++) {
          if (res[i].addressLine1) {
            this.sender.address_1 = res[i].addressLine1;
          }
          if (res[i].addressLine2) {
            this.sender.address_2 = res[i].addressLine2;
          }
          if (res[i].locality) {
            this.sender.address_3 = res[i].locality;
          }
          if (res[i].postalCode) {
            this.sender.postcode = res[i].postalCode;
          }
        }
      }
    },
    selectedGiftCard(img) {
      this.card_design = img;
      this.imageDesign = "_" + img;
    },
    touchField: function(field) {
      if (field && typeof field.touch === "function") {
        field.touch();
      }
      // if (this.$v.sender.postcodeSearch.$model !== "") {
      //   this.$v.sender.postcode.$model = this.$v.sender.postcode.$model.toUpperCase();
      // }
      // if (this.$v.recipient.postcode.$model !== ''){
      // this.$v.recipient.postcode.$model = this.$v.recipient.postcode.$model.toUpperCase()
      // }
      // this.$v.recipient.postcode.$model = this.$v.recipient.postcode.$model.toUpperCase()
    },
    validateState(group, name) {
      const { $dirty, $error } = this.$v[group][name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      this.formInvalid = false;
      this.paymentSuccess = false;
      this.paymentError = false;
      this.formInvalidModal = false;
      this.$v.$touch();
      // set standard fields
      this.processForm();
      // depending on payment type either show modal or load Amex Button
      if (this.paymentType === "Card" && !this.$v.$invalid) {
        this.buildSFData();
        this.data.giftCardData = this.sfData;
        this.$socket.emit("beginGiftCard", this.data);
      } else if (this.paymentType === "AMEX" && !this.$v.$invalid) {
        this.data.customerId = this.guid();
        this.loadAmexButton();
      } else {
        this.isLoading = false;
        this.formInvalidModal = true;
      }
    },
    processForm() {
      if (!this.$v.$invalid) {
        this.clicked.push("Submitted");

        this.data.billingAddressLine1 = this.sender.address_1;
        // this.data.postcode = this.sender.postcode
        this.data.billingAddressLine2 = this.sender.address_2;
        this.data.billingAddressLine3 = this.sender.address_3;
        this.data.billingAddressPostcode = this.sender.postcode;
        this.data.country = this.site;
        this.data.site = "TF";
        this.data.name =
          this.sender.title +
          " " +
          this.sender.firstname
            .normalize("NFD")
            .replace(/\p{Diacritic}/gu, "") +
          " " +
          this.sender.surname.normalize("NFD").replace(/\p{Diacritic}/gu, "");
        if (this.sender.countryCode !== null && this.intAddress == "yes") {
          this.data.countryCode = this.sender.countryCode;
        } else if (this.isIe) {
          this.data.countryCode = "IRL";
        } else {
          this.data.countryCode = "GBR";
        }
        this.data.title = this.sender.title;
        this.data.firstname = this.sender.firstname;
        this.data.surname = this.sender.surname;
        this.data.purchaseDescription = "GIFTCARD";
        this.data.cardvalue = parseInt(this.card.ccpayment);
        this.data.purchaseAmount = parseInt(this.card.ccpayment);
        this.data.currencyCode = this.currency;
        this.data.email = this.sender.email;
        this.data.phone = this.sender.phone;
        // EIRCODE
        if (this.isIe) {
          this.data.eircode = this.sender.postcode;
          this.data.address_4 = this.sender.address_4;
        } else {
          this.data.eircode = "";
        }
        this.data.payment_type = "CRD";
        this.data.staffid = "001";
        this.data.logname = "temp";
      } else {
        this.formInvalid = true;
      }
    },

    guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
      );
    },
    foundIEAddress(addressInfo) {
      if (addressInfo.postalAddress) {
        if (addressInfo.postalAddress[0]) {
          this.sender.address_1 = addressInfo.postalAddress[0];
        }
        if (addressInfo.postalAddress[1]) {
          this.sender.address_2 = addressInfo.postalAddress[1];
        }
        if (addressInfo.postalAddress[2]) {
          this.sender.address_3 = addressInfo.postalAddress[2];
        }
        if (addressInfo.postalAddress[3]) {
          this.sender.address_4 = addressInfo.postalAddress[3];
        }
        if (addressInfo.postcode) {
          this.sender.postcode = addressInfo.postcode;
        }
        this.addressFound = true;
      } else {
        this.addressFound = true;
      }
    },
    hideFrom(senderEmail, recipientEmail) {
      if (
        senderEmail === "100fullzg6@protonmail.com" ||
        recipientEmail === "100fullzg6@protonmail.com"
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  mounted() {
    this.meta.loaded = true;
    this.isIe = false;
    this.ref = ".com";
    this.GENERAL_CONFIG.CURRENCY = "£";
    this.GENERAL_CONFIG.TELEPHONE = "020 7408 9003";
    this.currency = "GBP";
    this.site = "UK";
    if (window.location.toString().indexOf("trailfinders.ie") > 0) {
      this.isIe = true;
      this.ref = ".ie";
      this.GENERAL_CONFIG.CURRENCY = "€";
      this.GENERAL_CONFIG.TELEPHONE = "01 702 9102";
      this.currency = "EUR";
      this.site = "IE";
    }
    if (window.innerWidth <= 1024) {
      this.img5a = "w_175,h_44";
    } else {
      this.img5a = "w_350,h_88";
    }
  },
};
</script>

<style lang="scss">
.b-form-datepicker {
  display: flex;
  flex-wrap: nowrap;
}
.b-calendar-footer {
  padding: 10px 10px 0 10px !important;
}
.b-form-datepicker .b-calendar-grid-body {
  .btn {
    padding: 9px 0 !important;
    width: 32px;
    height: 32px !important;
  }

  .small {
    line-height: normal;
  }
}
</style>
<style>
.autoaddress-control {
  max-width: 650px;
  margin: 10px 0;
  font-size: 15px;
  color: #777c89;
  font-family: inherit;
  position: relative;
  line-height: normal;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.autoaddress-control > .autoaddress-text-box {
  outline: 0;
  border: 0;
  border: 1px solid #dedede;
  border-radius: 3px;
  color: #999999;
  line-height: normal;
  line-height: 52px\9;
  height: 55px;
  width: 80%;
  box-sizing: border-box;
  background: #fff;
  font-size: 16px;
  color: #666;
  margin: 0;
  padding: 0 10px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  float: left;
}
.autoaddress-control > .autoaddress-button {
  background-color: #9cc06e;
  border: 1px solid #9cc06e;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  font-size: 20px;
  font-weight: 400;
  line-height: normal;
  height: 55px;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
  width: 20%;
  margin: 0;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  clear: right;
  position: relative;
  box-sizing: border-box;
}
.autoaddress-control .autoaddress-autocomplete {
  border: solid 1px #ccc;
  position: absolute;
  z-index: 1;
  width: 99.8%;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: 0 6px 12px rgb(0 0 0 / 30%);
}
.designs {
  border-radius: 15%;
  padding-bottom: 20px;
}

.designs:hover {
  cursor: pointer;
}

.chosenCard {
  opacity: 0.5;
}

.date .form-control[readonly] {
  cursor: pointer;
  background-color: #fafafa;
}

.highlightCard {
  border: 3px solid red;
}

.express-vue-temp .modal {
  overflow: scroll;
}

.express-vue-temp .modal-header {
  justify-content: flex-start;
}

.express-vue-temp
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label:after {
  background-color: #9cc06e;
  color: #fff;
  border-radius: 50%;
}

label {
  vertical-align: -webkit-baseline-middle !important;
}

.express-vue-temp .custom-control-label {
  padding-top: 1.5%;
  font-weight: 100;
  font-size: initial;
}

.express-vue-temp
  .custom-control-input:checked
  ~ .custom-control-label::before {
  color: #fff;
  border-color: #9cc06e;
  background-color: #9cc06e;
}

.express-vue-temp .alert {
  font-size: 15px;
}

#payment-frame {
  border: 0px;
  margin: auto;
  width: 100%;
  height: 400px;
}
.modalText {
  font-family: Arial "sans-serif";
  font-size: 33px;
  color: #fff;
  padding: 0;
  margin: 0;
}
.modalPayText {
  font-family: Arial, "sans-serif";
  font-size: 48px;
  color: #fff;
  padding: 0;
  margin: 0;
  line-height: 0;
}
.modalCardNo {
  font-family: Arial, "sans-serif";
  font-size: 38px;
  color: #fff;
  padding: 0;
  margin: 0;
  line-height: 30px;
}
.max-width {
  width: auto;
}
@media only screen and (max-width: 1024px) {
  .img1 {
    width: 65px;
    height: 85px;
  }
  .img2 {
    width: 175px;
    height: 85px;
  }
  .img3 {
    width: 60px;
    height: 85px;
  }
  .img4 {
    width: 65px;
    height: 44px;
  }
  .img5 {
    width: 175px;
    height: 44px;
  }
  .img6 {
    width: 60px;
    height: 44px;
  }
  .img7 {
    width: 65px;
    height: 61px;
  }
  .img8 {
    width: 175px;
    height: 61px;
  }
  .img9 {
    width: 60px;
    height: 61px;
  }
  .modalText {
    font-family: Arial "sans-serif";
    font-size: 16px;
    color: #fff;
    padding: 0;
    margin: 0;
  }

  .modalPayText {
    font-family: Arial, "sans-serif";
    font-size: 18px;
    color: #fff;
    padding: 0;
    margin: 0;
    line-height: 0;
  }

  .modalCardNo {
    font-family: Arial, "sans-serif";
    font-size: 14px;
    color: #fff;
    padding: 0;
    margin: 0;
    line-height: 15px;
  }

  /* .maxWidth{
          max-width: 350px;
        } */
}

.autoaddress-control
  .autoaddress-autocomplete
  .autoaddress-suggestion.autoaddress-search {
  background-color: #fff !important;
}
.b-form-datepicker .b-calendar-grid-body .col {
  margin: 0;
}
.b-form-datepicker.is-valid {
  background-image: none;
  padding-right: 5px;
}
.b-form-datepicker.is-invalid {
  background-image: none;
  padding-right: 5px;
}
</style>
